<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12 lg12 md12 style="display: flex; flex-wrap: wrap; align-items: center;">
          <v-flex xs12 md6 lg4>
              <v-card @click="importMonoTrainScheduleDialog=true; monotrain=true; monoschedule=false;"
                      class="mx-auto"
                      max-width="340" style="cursor: pointer;"
              >
                <div style="display: flex;justify-content: center;align-items: center;">
                  <v-icon color="#bbbbc6" style="font-size: 100px;"
                          class="black--text mr-2">subway</v-icon></div>
                <!--              <v-span name="local" style="font-size: 200%;margin:20px;color:#A52A2A;"></v-span>-->
                <v-card-title style="display: flex;justify-content: center;align-items: center;">

                  Import Mono Trains
                </v-card-title>
              </v-card>
          </v-flex>


          <v-flex xs12 md6 lg4>
            <v-card @click="importMonoTrainScheduleDialog=true; monotrain=false; monoschedule=true;"
                    class="mx-auto"
                    max-width="340" style="cursor: pointer;">
              <div style="display: flex;justify-content: center;align-items: center;">
                <v-icon color="#bbbbc6" style="font-size: 100px;"
                        class="black--text mr-2">subway</v-icon>
              </div>

              <v-card-title style="display: flex;justify-content: center;align-items: center;">
                Import Mono Train Schedule
              </v-card-title>
            </v-card>
          </v-flex>


          <v-flex xs12 md6 lg4>
              <v-card @click="downloadCompleteTrainSchedule=true"
                      class="mx-auto"
                      max-width="340" style="cursor: pointer;"
              >
                <div style="display: flex;justify-content: center;align-items: center;">
                  <v-icon color="#bbbbc6" style="font-size: 100px;"
                          class="black--text mr-2 material-icons">cloud_download</v-icon></div>
                <!--              <v-span name="local" style="font-size: 200%;margin:20px;color:#A52A2A;"></v-span>-->
                <v-card-title style="display: flex;justify-content: center;align-items: center;">

                  Export Mono Trains/Schedule
                </v-card-title>
              </v-card>
          </v-flex>
        </v-flex>


        <v-dialog v-model="importMonoTrainScheduleDialog" max-width="600">
          <v-card>
            <v-card-title class="headline justify-space-between pb-0">
              <span v-if="monotrain == true">Import Mono Trains</span>
              <span v-if="monoschedule == true">Import Mono Train Schedule</span>
              <v-btn icon @click="importMonoTrainScheduleDialog = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>

            <v-form ref="monoTrainScheduleImport"
                    id="monoTrainScheduleImport"
                    lazy-validation
                    v-model="valid"
                    data-vv-scope="monoTrainScheduleImport"
                    @submit.prevent="validateBeforeSubmit('monoTrainScheduleImport')">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md12>
                    <input type="file" name="master_data_file" ref="fileupload" accept="*/*" id="master_data_file"/>
                  </v-flex>
                </v-layout>
              </v-card-text>

              <br /><br />

              <v-card-actions>
                <v-layout>
                  <a target="_blank" v-if="monotrain == true"
                     :href="getBackendPublicURL('/MonoTrain-Schedule/Sample_Mono_Train.csv')">Click
                    here to Download Train Sample File</a>

                  <a target="_blank" v-if="monoschedule == true"
                     :href="getBackendPublicURL('/MonoTrain-Schedule/Sample_Mono_Schedule.xlsx')">Click
                    here to Download Schedule Sample File</a>
                  <v-spacer></v-spacer>
                  <v-btn type="submit"
                         class="mr-3 mb-3"
                         :disabled="!valid || submit_loader"
                         color="primary"
                         :loading="submit_loader">Submit
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-card>


        </v-dialog>




        <!--        export mono train and schedule-->
        <v-dialog v-model="downloadCompleteTrainSchedule" max-width="600">
          <v-card>
            <v-card-title class="headline justify-space-between pb-0">
              <v-flex xs12 md12 lg12 style="display: flex;justify-content: space-between;">
                <span>Export MonoTrains/Schedules</span>
                <v-btn icon @click="downloadCompleteTrainSchedule = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form ref="exportMonoData"
                    id="exportMonoData"
                    v-model="valid"
                    lazy-validation
                    data-vv-scope="exportMonoData"
                    @submit.prevent="validateBeforeSubmit('exportMonoData')">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-select
                        solo flat
                        v-model="exportType"
                        :loading="loading_lines"
                        :items="types"
                        item-text="type"
                        item-value="value"
                        label="Select Option To Export"
                        :error-messages="errors.collect('exportMonoData.line_id')"
                        v-validate="'required'"
                    ></v-select>
                  </v-flex>

                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-layout justify-end>
                  <v-btn type="submit"
                         class="mr-3 mb-3"
                         :disabled="(exportType == '')"
                         color="primary"
                         :loading="loading_submit">Export
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>

        <v-snackbar
            :color="snackBar.color"
            :top="snackBar.top"
            :bottom="snackBar.bottom"
            :left="snackBar.left"
            :right="snackBar.right"
            v-model="snackBar.show"
        >
          {{ snackBar.message }}
          <v-btn dark flat @click.native="snackBar.show = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-snackbar>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "MonoImport",
  data() {
    return {
      importMonoTrainScheduleDialog: false,
      downloadCompleteTrainSchedule: false,
      monotrain: false,
      monoschedule: false,
      submit_loader: false,
      valid: false,
      snackBar: {
        show: false,
        color: "",
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false
      },
      loading_lines: false,
      loading_submit: false,
      exportType: '',
      types: [
        {type: 'Mono Trains', value:'train'},
        {type: 'Mono Schedules', value: 'schedule'}
      ]
    }
  },
  methods:{
    validateBeforeSubmit(scope){
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this[scope]();
        }
      });
    },
    getBackendPublicURL(filePath) {
      return `${process.env.VUE_APP_API_URL}/${filePath}`
    },
    monoTrainScheduleImport(){
      this.startLoading();
      this.submit_loader = true;

      let URL = '';
      if(this.monotrain ==  true){
        URL = 'import-mono-trains'

      }else if(this.monoschedule == true){
        URL = 'import-mono-schedule'
      }


      var myForm = $('#monoTrainScheduleImport')[0];
      let formData = new FormData(myForm);
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/`+ URL, formData, {headers: this.$headers})
          .then((response) => {
            this.storeDialog = false
            if (response.data.status == 1) {

              const url = `${process.env.VUE_APP_API_URL}/` + response.data.data;
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', response.data.data);
              document.body.appendChild(link);
              link.click();
              this.importMonoTrainScheduleDialog = false;
              this.$refs.monoTrainScheduleImport.reset();
              this.file = '';
              document.getElementById("master_data_file").value = "";
              this.$refs.fileupload.value = null;
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
            } else {
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.importMonoTrainScheduleDialog = false;
              this.file = '';
              // this.$refs.monoTrainScheduleImport.reset();
              document.getElementById("master_data_file").value = "";
            }
          }).finally(() => {
        this.submit_loader = false;
        this.importMonoTrainScheduleDialog = false;
        this.stopLoading();
      });
    },
    download(type,data) {
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;

      var exportType;
      if(type == 'train'){
        exportType = "Train"
      }else if(type == 'schedule'){
        exportType = "Schedule"
      }
      link.setAttribute('download',
          'Mono_'+ exportType +"_" + moment().format('YYYY-MM-DD')
          + '.csv');
      document.body.appendChild(link);
      link.click();
    },
    exportMonoData(){
      let formData = new FormData;
      formData.append('type', this.exportType);
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/export-mono-data`, formData, {headers: this.$headers,
        responseType: 'blob'}).then(
          (response)=>{
            if(response.data){
              this.stopLoading();
              this.download(this.exportType, response.data);
              this.downloadCompleteTrainSchedule = false;
              this.exportType = '';

            }else if(response.data.status == 0){
              this.stopLoading();
              this.snackBar.message = response.data.message;
              this.snackBar.show = true;
              this.downloadCompleteTrainSchedule = false;
              this.exportType = '';
            }
          }
      ).catch((error)=>{
        this.snackBar.message = "Error Occurred";
        this.snackBar.show = true;
        this.stopLoading();
        this.downloadCompleteTrainSchedule = false;
        this.exportType = '';
      })
    }
  }
}
</script>

<style scoped>

</style>
